import { Grid, Typography, useTheme } from '@mui/material'

import usePauseDevice from '../../utils/hooks/usePauseDevice'

import useStyles from './index.styles'

const PauseDuration = ({ device, timezone }: { device: IDeviceAPIObject; timezone?: string }) => {
  const classes = useStyles
  const theme = useTheme()
  const { isPaused, willBePaused, pausedText } = usePauseDevice({ device, timezone })

  return (
    <>
      {(isPaused || willBePaused) && (
        <Grid size={12} container={true}>
          <Grid
            sx={{
              ...classes.container(theme),
              backgroundColor: isPaused ? '#e8f7f0' : theme.palette.grey[200],
              borderColor: isPaused ? '#bfecd7' : theme.palette.grey[300],
            }}
          >
            <Typography variant="caption">{pausedText}</Typography>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default PauseDuration
